import { render, staticRenderFns } from "./manuales.vue?vue&type=template&id=0f05a7d0"
import script from "./manuales.vue?vue&type=script&lang=js"
export * from "./manuales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports